import { useEffect } from "react";
import { useModalStackStore } from "src/stores/modalStackStore";

export function useModalStackEscapeHandler() {
  const closeTopmost = useModalStackStore((s) => s.closeTopmost);
  const hasModals = useModalStackStore((s) => s.stack.length > 0);

  useEffect(() => {
    if (!hasModals) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        // Stop propagation so other handlers (like Radix Dialog) don't also close
        e.stopPropagation();
        closeTopmost();
      }
    };

    // Use capture phase to handle before Radix Dialog's handler
    document.addEventListener("keydown", handleEscape, true);
    return () => document.removeEventListener("keydown", handleEscape, true);
  }, [hasModals, closeTopmost]);
}
